import React from "react";
import { useDispatch } from "react-redux";
import HouseVisitBookingTemplate from "./HouseVisitBookingTemplate";
import CenterListTemplate from "../CenterListTemplate";
import { setCenterSelected } from "../../../../../Redux/BookMedicalVisit/action";
import { BookVisitDetails } from "../../../CommonData";
import PAGE_CONSTANTS from "../../constant";
import "./houseVisit.css";


const HouseVisitTemplate = ({ selectedMember, bookAppointment, tpaDetails }) => {
  const dispatch = useDispatch();
  const { [selectedMember?.MemberId]: bookState } = BookVisitDetails();
  const {
    selectedCenter,
    dcList
  } = bookState || {}

  const onBookAppointmentClick = (clinic) => {
    dispatch(setCenterSelected({ memberId: selectedMember?.MemberId, value: clinic}));
  };

  return (
    <>
      {selectedCenter ? (
        <HouseVisitBookingTemplate
          selectedMember={selectedMember}
          bookAppointment={bookAppointment}
          tpaDetails={tpaDetails}
        />
      ) : (
        <CenterListTemplate
          dcList={dcList}
          tpaDetails={tpaDetails}
          onBookAppointmentClick={onBookAppointmentClick}
          type={PAGE_CONSTANTS?.HOME_VISIT_TYPE}
        />
      )}
    </>
  );
};

export default HouseVisitTemplate;
